import dayjs from "@tc/ui-dfe/utils/libs/dayjs"

export const getStartAndEndTimestamp = (timestamp: number) => {
  const date = dayjs(timestamp).tz("Pacific/Auckland")

  return {
    startTimestamp: date.startOf("day").valueOf(),
    endTimestamp: date.endOf("day").valueOf(),
  }
}

export const isSameDay = (timestamp1: number, timestamp2: number) => {
  const date1 = dayjs(timestamp1).tz("Pacific/Auckland")
  const date2 = dayjs(timestamp2).tz("Pacific/Auckland")

  return date1.format("YYYY-MM-DD") === date2.format("YYYY-MM-DD")
}
